<template>
  <v-container class="new-campaign-finish">
    <p class="title-text mt-2">{{$t('NewCampaignInitialData.finish.title')}}</p>
    <p class="body-text text-center mt-2" v-html="$t('NewCampaignInitialData.finish.body')" />
    <v-row justify="center" align="end" class="mt-2">
      <v-btn :loading="loading" color="#0098E1" class="submit-button" @click="finishOnboarding()">{{$t('NewCampaignInitialData.finish.goToDashboard')}}</v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { completePreDataStep } from '../../lib/crudOperations/write'
import { FIRESTORE_CAMPAIGN_PRE_DATA_STEPS } from '../../constants/const'
import { trackEvent } from '../../lib/track-events'
import { EVENTS_TO_TRACK } from '../../constants/const'

export default {
  name: 'NewCampaignFinish',
  props: {
    nextStep: {
      type: Function,
      required: true
    },
    campaignId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    async finishOnboarding () {
      try {
        this.loading = true
        trackEvent(EVENTS_TO_TRACK.CLICK_CAMPAIGN_ONBOARDING_FINISH_BUTTON, {
          campaignId: this.campaignId
        })
        await completePreDataStep(this.campaignId, FIRESTORE_CAMPAIGN_PRE_DATA_STEPS.FINISH)
        await this.nextStep()
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// NewCampaignFinish.vue?62c02862